<template>
    <div class="app has-header">
        <div class="header main">
            
            <div class="align-left">
                
            </div>
            <div class="align-middle">
               <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
            </div>
        </div>
        <div class ="tablecontainer scrollbar-container">
             <datatable :state="dataTableState"/>
        </div>  
    <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
  </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'locationoverview',
    components: {
        datatable
    },
  data () {
    return {

        error: false,
        loading: true,
        loadingText: null,
    }
  },
  
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'locationMap', 'storeSettings', 'isSuperUser']),
        headerButtons(){

            let view = this;

            let state= {
                buttons: []
            };
            //BUTTON 1
            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refresh(true); 
                },
                tooltip: this.$t('global.general.refreshData')
            });
            state.buttons.push({
                    type: "block green", 
                    icon: "fa-plus",
                    click: ($event) => {view.OpenCreateLocationModal($event)},
                    tooltip: this.$t('shift.location.addLocation'),
                    helperText: this.$t('shift.location.addLocationHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/b826791f-6f4d-4473-a65e-87eba3c3a7c5/article/2549809153"
            });
            state.buttons.push({
                    type: "block orange", 
                    icon: "fa-plus",
                    click: ($event) => {view.OpenCreateCompanyLocationsModal($event)},
                    tooltip: this.$t('shift.location.addCompanyLocations'),
                    helperText: this.$t('shift.location.addCompanyLocationsHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/b826791f-6f4d-4473-a65e-87eba3c3a7c5/article/2549809153"
            });
            state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close'),
                    }
                ];
            return state;
        },
    
        dataTableState(){
            let view = this;
            
            let state = {};
            
            let values = Object.values(this.locationMap);
            
            state = this.$helpers.GetDataTableStateFromObject({name: '', longitude: '', latitude: '', gpsRange: '', externalStoreName: '', actions: ''},values);
            
           

            
            state.headerMap['name'].sort = false;
            state.headerMap['name'].label = this.$t('pages.employeeData.name');
            state.headerMap['name'].align = 'center';
            

            state.headerMap['longitude'].sort = false;
            state.headerMap['longitude'].label = this.$t('shift.location.longitude');
            state.headerMap['longitude'].align = 'center';
            state.headerMap['longitude'].DisplayLabel = (i) => {return i.longitude.toFixed(5)};
        

            state.headerMap['latitude'].sort = false;
            state.headerMap['latitude'].label = this.$t('shift.location.latitude');
            state.headerMap['latitude'].align = 'center';
            state.headerMap['latitude'].DisplayLabel = (i) => {return i.latitude.toFixed(5)};

            state.headerMap['gpsRange'].sort = false;
            state.headerMap['gpsRange'].label = this.$t('shift.location.punchRadius');
            state.headerMap['gpsRange'].align = 'center';
            state.headerMap['gpsRange'].DisplayLabel = (i) => {return i.gpsRange+'m'};

            state.headerMap['externalStoreName'].sort = false;
            state.headerMap['externalStoreName'].label = this.$t('shift.location.externalOperation');
            state.headerMap['externalStoreName'].align = 'center';
            state.headerMap['externalStoreName'].DisplayLabel = (i) => {return i.externalStoreName != null ? i.externalStoreName : '-'};
            
            
            
            state.headerMap['actions'] = {align: 'center', label: ' ',
                buttons:[
                    {icon: 'fas fa-edit', action: ($event, data) => view.OpenEditLocationModal($event, data)}, 
                    {icon: 'fas fa-trash', action: ($event, data) => view.OpenDeleteLocationModal($event, data)},
                ]
            };
            
            state.headerMap['actions'].width = '100px'; 
            
            
            return state;
        },
    },
    watch: { 
        storeId: function(val, oldVal) {
            this.refresh(true);
        },
    },
  // methods that implement data logic.
    methods: {
        refresh: function(force = false) {
            let view = this;
            this.loading = true;
            return view.$helpers.GetLocationMap(force)
            .then(map=>{
                view.loading = false;
            })
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                console.log(error)
            });
        },
        OpenCreateLocationModal($event){
            let view = this;
            
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: null},
                        {label: this.$t('store.settings.location'), key: 'location', hidden: false, type: 'location', value: {lat: this.storeSettings.latitude, lng: this.storeSettings.longitude}, showInitialMarker: false, interactive: true},
                        
                        {label: this.$t('shift.location.punchRadiusMeter'), key: 'gpsRange', hidden: false, type: 'numeric', value: 50},
                    ],
                    errorCheck: [
                        (entries) => {
                            let r = entries.gpsRange != null ? parseInt(entries.gpsRange) : null;
                            if(r == null || isNaN(r) || r <= 0){
                                return {key: 'gpsRange', type: 'error', label: this.$t('shift.location.punchRadius'), text: 'Bitte geben Sie einen gültigen Stempel Radius ein'}
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (item) {
                        item.gpsRange = parseInt(item.gpsRange);
                        view.createLocation(item);
                    }
                },
                header: this.$t('shift.location.newLocation'),
                centered: true,
                expanded: true,
            });
        },
        createLocation: function(item){
            let view = this;
            let url = '/api/sec/location';
            let params = {
                storeId: this.storeId,
            }

            let payload = {
                storeId: this.storeId,
                name: item.name,
                longitude: item.location.lng,
                latitude: item.location.lat,
                gpsRange: item.gpsRange
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setLocationMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$tc('shift.location.locationAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.location.addLocationError'));
                console.log(error)
            })

        },
        OpenCreateCompanyLocationsModal($event){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('shift.location.addCompanyLocations'), description: this.$t('shift.location.addCompanyLocationsQuery'), callbackAccept: (alert) => {
                alert.hidden = true;
                view.createCompanyLocations();
            }});
        },
        createCompanyLocations: function(){
            let view = this;
            let url = '/api/sec/location/company';
            let params = {
                storeId: this.storeId,
            }


            

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
            }).then(response => {
                
                view.$helpers.success(view.$t('global.notifications.success'), view.$tc('shift.location.locationAdded', 2));
                view.refresh(true);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.location.addLocationsError'));
                console.log(error)
            })

        },
        OpenDeleteLocationModal($event, data){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('shift.location.deleteLocation'), description: this.$t('shift.location.deleteLocationQuery', [data.name]), callbackAccept: (alert) => {
                alert.hidden = true;
                view.deleteLocation(data);
            }});
        },
        deleteLocation: function(item){
            let view = this;
            let url = '/api/sec/location';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }
           

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteLocationMapEntry", {id: item.id});
                view.$store.commit("invalidateState", {states: ['planShiftMapState', 'shiftTemplateMapState']});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.location.locationDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.location.deleteLocationError'));
                console.log(error)
            })

        },
        OpenEditLocationModal($event, item){
            let view = this;
           
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id},
                        {label: 'Store Id', key: 'externalStoreId', hidden: true, type: 'text', value: item.externalStoreId},
                        {label: this.$t('pages.employeeData.name'), key: 'name', hidden: item.externalStoreId != null, type: 'text', value: item.name},
                        {label: this.$t('store.settings.location'), key: 'location', hidden: false, type: 'location', value: {lat: item.latitude, lng: item.longitude}, showInitialMarker: true, interactive: item.externalStoreId == null},
                        //{label: 'Latitude', key: 'latitude', hidden: item.externalStoreId != null, type: 'numeric', value: item.latitude},
                        //{label: 'Longitude', key: 'longitude', hidden: item.externalStoreId != null, type: 'numeric', value: item.longitude},
                        {label: this.$t('shift.location.punchRadiusMeter'), key: 'gpsRange', hidden: false, type: 'numeric', value: item.gpsRange},
                       
                    ],
                    errorCheck: [
                        (entries) => {
                            let r = entries.gpsRange != null ? parseInt(entries.gpsRange) : null;
                            if(r == null || isNaN(r) || r <= 0){
                                return {key: 'gpsRange', type: 'error', label: this.$t('shift.location.punchRadius'), text: 'Bitte geben Sie einen gültigen Stempel Radius ein'}
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (item) {
                        item.gpsRange = parseInt(item.gpsRange);
                        view.editLocation(item);
                    },
                    
                },
                header: this.$t('shift.location.editLocation'),
                centered: true,
                expanded: true,
            });
        },
        editLocation: function(item){
            let view = this;
            let url = '/api/sec/location';
            let params = {
                
                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                storeId: this.storeId,
                name: item.name,
                longitude: item.location.lng,
                latitude: item.location.lat,
                gpsRange: item.gpsRange,
                updateFields: ["name", "longitude", "latitude", "gpsRange"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.locationMap[item.id]
                data.name = payload.name;
                data.longitude = payload.longitude;
                data.latitude = payload.latitude;
                data.gpsRange = payload.gpsRange;

                view.$store.commit("setLocationMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.location.locationEdited'));
            }).catch(function (error) {
               view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.location.editLocationError'));
               console.log(error)
            })

        },
        
        
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }
 
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .header.date{
        display: inline-flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        left: 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
        margin-top: -3px;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin-right: 5px;
        margin-top: -3px;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
        margin-top: -3px;
    }
    .header.date .fa-angle-left{
        margin: 0 10px;
        font-size: 25px;
        color: var(--contrast-4);
    }
    .indicator-view{
        padding: 30px;
        padding-bottom: 50px;
    }
</style>
